module.exports = __webpack_public_path__ + "img/Support-skill-615.4489dbd8.png";